import { useViewport } from '@tryhackme/thm-ui-components';
import { BREAKPOINTS } from 'src/common/constants/breakpoints';
import { useGetSearchProgressQuery } from 'src/features/hacktivities/search/content/content.slice';
export const useShouldSeeStartVmExpand = (roomCode: string, activeAccordion: number | null) => {
  const {
    width
  } = useViewport();
  const {
    data: searchProgress
  } = useGetSearchProgressQuery({
    roomCodes: roomCode
  });
  if (!activeAccordion || width < BREAKPOINTS.MOBILE) return false;
  if (activeAccordion !== 2 || roomCode !== 'offensivesecurityintro') {
    return false;
  }
  const progressPercentage = searchProgress?.data?.roomProgress?.[0]?.progressPercentage;
  // 20% percent completion is the first question
  if (typeof progressPercentage !== 'number' || progressPercentage > 20) return false;
  return true;
};